// Type definitions for table-specific state
// Each FlexTable instance maintains its own state to avoid conflicts
export type TableState = {
  itemsPerPage: Record<number, number[]>;
  rowToPageMap: Record<number, number>;
};

// Module-level state store for all table instances
// Maps table IDs to their individual state objects
const tableStateStore: Map<string, TableState> = new Map();

export const createTableState = (): TableState => ({
  itemsPerPage: {},
  rowToPageMap: {}
});

/**
 * Gets or creates table-specific state from module-level store
 * @param tableId Unique identifier for the table instance
 * @returns TableState for the given table ID
 */
export const getTableState = (tableId: string): TableState => {
  if (!tableStateStore.has(tableId)) {
    tableStateStore.set(tableId, createTableState());
  }
  return tableStateStore.get(tableId)!;
};

/**
 * Cleans up table state and callbacks from module-level store (optional cleanup)
 * @param tableId Unique identifier for the table instance
 */
export const clearTableState = (tableId: string): void => {
  tableStateStore.delete(tableId);
};
